var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacherDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3999C9.62004 13.3999 10.9333 12.0866 10.9333 10.4666C10.9333 8.84651 9.62004 7.5332 8 7.5332C6.37996 7.5332 5.06665 8.84651 5.06665 10.4666C5.06665 12.0866 6.37996 13.3999 8 13.3999Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36063 16.3331C3.77727 15.4554 4.43433 14.7139 5.25553 14.1947C6.07673 13.6755 7.02837 13.3999 7.99994 13.3999C8.97151 13.3999 9.92315 13.6755 10.7443 14.1947C11.5655 14.7139 12.2226 15.4554 12.6392 16.3331L18.2666 16.3333C18.363 16.3333 18.4583 16.3143 18.5473 16.2774C18.6363 16.2406 18.7171 16.1866 18.7852 16.1185C18.8533 16.0504 18.9073 15.9695 18.9442 15.8806C18.981 15.7916 19 15.6962 19 15.5999V2.39984C19 2.20535 18.9227 2.01882 18.7852 1.88129C18.6477 1.74377 18.4612 1.6665 18.2667 1.6665H2.13324C1.93875 1.6665 1.75222 1.74377 1.61469 1.88129C1.47716 2.01882 1.3999 2.20535 1.3999 2.39984V15.6C1.3999 15.6963 1.41887 15.7916 1.45573 15.8806C1.49258 15.9696 1.5466 16.0504 1.6147 16.1185C1.68279 16.1866 1.76364 16.2406 1.85261 16.2775C1.94158 16.3143 2.03694 16.3333 2.13324 16.3333L3.36063 16.3331Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 13.4001H16.0667V4.6001H4.33325V6.06677",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherDetails);
export default __webpack_public_path__ + "static/media/teacherDetails.e4c8cb01f31642989d909b3ec3459648.svg";
export { ForwardRef as ReactComponent };